<template>
    <div class="popup__block">
        <a href="/" class="popup__close"></a>
        <div class="popup__title">Подтверждение регистрации</div>
        <div v-if="expired">
            <center><p>Время действия кода подтверждения истекло.</p></center>
        </div>
        <div v-else-if="timeLeft > -1">
            <center><p>На ваш e-mail отправлен код подтверждения, который будет действителен в течение {{ timeStr }} минут.</p></center>
        </div>

        <div v-else>
            <center><p>Код подтверждения действителен в течение 15 минут.</p></center>
        </div>
        <br/>
        <div class="popup-review">
            <form @submit.prevent="debounce(validate)" class="form">
                <div class="form__inputs">
                    <div class="default-input">
                        <input @paste.prevent="removeFirstDigit" @input="this.reset" v-model="email" class="default-input__input"
                               :class="{'default-input__input--error':errors.some(er => er.code === 5)}" type="text" placeholder="E-mail*">
                        <span v-if="errors.some(er => er.code === 5)" class="default-input__error"></span>
                    </div>
                    <div class="default-input">
                        <input @paste.prevent="removeFirstDigit" @input="this.reset" v-model="confirmation" class="default-input__input"
                               :class="{'default-input__input--error':errors.some(er => er.code === 12 || er.code === 13)}" type="text" placeholder="Код">
                        <span v-if="errors.some(er => er.code === 12 || er.code === 13)" class="default-input__error"></span>
                    </div>
                </div>
                <div style="display: none">
                    <vue-recaptcha
                        ref="recaptcha"
                        size="invisible"
                        :sitekey="this.site_key"
                        @verify="sendData"
                        @expired="onCaptchaExpired"
                    />
                </div>
                <div class="form__submit">
                    <input v-if="!expired" class="btn btn--mini" type="submit" value="Отправить"/>
                    <input v-else class="btn btn--mini" type="submit" value="Отправить код повторно"/>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import recaptcha from "@/components/mixins/recaptcha";
import errors from "@/components/mixins/errors";
import tools from "@/components/mixins/tools";

export default {
    name : "ConfirmationForm",
    props: ['time_prop', 'email_prop'],
    data() {
        return {
            email       : '',
            confirmation: '',
            timer       : {
                ms: -1
            },
            expired     : false,
            code_sent   : true
        }
    },
    computed: {
        timeStr() {
            let min = Math.floor(this.timer.ms / 60).toFixed(0);
            let sec = Math.floor(this.timer.ms - (min * 60)).toFixed(0);
            return (min < 10 ? '0' + min : min) + ':' + (sec < 10 ? '0' + sec : sec);
        },
        can_send_code() {
            return this.timer.ms < 1 || this.expired;
        },
        timeLeft() {
            return this.timer.ms;
        }
    },
    mixins  : [recaptcha, errors, tools],
    methods : {
        sendData(recaptchaToken) {
            this.reset();
            let formData = new FormData();
            formData.append('email', this.email);
            if(!this.can_send_code)
            {
                formData.append('confirmation', this.confirmation);
                this.code_sent = true;
            }
            else
            {
                formData.append('send_code', 'true');
                this.code_sent = false;
            }
            formData.append('token', recaptchaToken);
            fetch("/api/user/registration/confirm/", {method: 'POST', body: formData})
                .then(response => response.json())
                .then(async resp => {
                    if(resp.success !== true)
                    {
                        let errs = JSON.parse(resp.message);
                        this.parse(errs);
                        console.log(errors);
                        this.code_sent = !errors.some(er => er.code === 13);
                    }
                    else
                    {
                        this.reset();
                        if(resp.data)
                        {
                            this.timer.ms = parseInt(resp.data.timeLeft);
                            this.startTimer(this.timer);
                        }
                        else
                            location.href = '/personal/private/';
                    }
                });
        },
    },
    mounted() {
        switch(this.time_prop)
        {
            case null:
                this.expired = true;
                break;
            case this.time_prop > 0:
                this.timer.ms = parseInt(this.time_prop);
                this.startTimer(this.timer);
                break;
        }
        if(this.email_prop)
            this.email = this.email_prop;

    }
}
</script>

<style scoped>

</style>